// Banner slider

var elem = document.querySelector('.main-carousel');
var flkty = new Flickity( elem, {
  // options
  cellAlign: 'left',
  contain: true,
  freeScroll: false,
  wrapAround: true,
  autoPlay: true,
  // disable previous & next buttons and dots
  prevNextButtons: false,
  pageDots: true,
  lazyLoad: 1,
  adaptiveHeight: false
});
